/**
 * Largura mínima (px) da janela para usar os layouts Lista e Tabela, que dispõem as informações na horizontal.
 * Abaixo dela o layout Cards é o único utilizado e o seletor de layout fica oculto.
 */
export const LARGURA_MINIMA_LISTA_E_TABELA = 900;
